export const Debito = [
    {text: 'Credito', value: 'Credito'},
    {text: 'Debito', value: 'Debito'},
]